export default __webpack_public_path__ + "static/media/coming soon.311080d8.svg";